import { useSyncExternalStore } from 'react';

/** Fraction (0..1) of the chat+panel split that the artifact panel takes.
 *  Default 0.6 = 40:60 (chat:panel). Persisted to localStorage. */
const STORAGE_KEY = 'agentica.devPanelSplit';
const DEFAULT_SPLIT = 0.6;

const readInitial = (): number => {
  if (typeof localStorage === 'undefined') return DEFAULT_SPLIT;
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    if (v == null) return DEFAULT_SPLIT;
    const n = Number(v);
    if (!Number.isFinite(n) || n <= 0 || n >= 1) return DEFAULT_SPLIT;
    return n;
  } catch {
    return DEFAULT_SPLIT;
  }
};

let ratio = readInitial();
const listeners = new Set<() => void>();

const subscribe = (l: () => void) => {
  listeners.add(l);
  return () => {
    listeners.delete(l);
  };
};

const getSnapshot = () => ratio;

export const setDevPanelSplit = (next: number) => {
  if (ratio === next) return;
  ratio = next;
  try {
    localStorage.setItem(STORAGE_KEY, String(next));
  } catch {
    /* ignore storage errors */
  }
  listeners.forEach((l) => l());
};

export const useDevPanelSplit = (): number =>
  useSyncExternalStore(subscribe, getSnapshot, getSnapshot);

export const DEV_PANEL_SPLIT_PRESETS: { chat: number; panel: number }[] = [
  { chat: 30, panel: 70 },
  { chat: 40, panel: 60 },
  { chat: 50, panel: 50 },
  { chat: 60, panel: 40 },
  { chat: 70, panel: 30 },
];
